import { render } from "./Location.vue?vue&type=template&id=5cb0568a&scoped=true"
import script from "./Location.vue?vue&type=script&lang=js"
export * from "./Location.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5cb0568a"

export default script